module.exports = __webpack_public_path__ + "img/icon08.a3a1a003.png";